import React from 'react';
import { compose } from 'redux';
import Breadcrumb from '@components/Breadcrumb';
import ContainerBody from '@components/ContainerBody';
import { withPaginate } from '@contexts/Paginate/PaginateContext';
import ManagePermissionsPage from './index';

const ManagePermissions = () => {
  return (
    <ContainerBody>
      <div className="breadcrumb">
        <Breadcrumb homePath={'/dashboard'} routeSegments={[{ name: 'Quản lý quyền hạn' }]} />
      </div>
      <ManagePermissionsPage />
    </ContainerBody>
  );
};

export default compose(withPaginate)(ManagePermissions);
